import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  alertAnatomy.keys,
);

export const Alert = defineMultiStyleConfig({
  baseStyle: {
    container: {
      color: "white",
    },
  },

  variants: {
    subtle: ({ colorScheme }) => {
      let bg: string = "";

      switch (colorScheme) {
        case "primary":
          bg = "highlight.fg";
          break;
        case "orange":
          bg = "warning.fg";
          break;
        case "red":
          bg = "error.fg";
          break;
      }

      return {
        container: {
          bg,
        },
      };
    },
  },
});
